import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { firstValueFrom, Subscription } from 'rxjs';
import { PreInvoicingAlertModel } from 'src/app/models/invoicing/pre-invoicing-alert.models';
import { ConfirmDialogService } from 'src/app/services/confirm-dialog/confirm-dialog.service';
import { AccountingInterfaceService } from 'src/app/services/invoicing/accounting-interface.service';

@Component({
  selector: 'app-synchronizer-accounting-interface',
  templateUrl: './synchronizer-accounting-interface.component.html',
  styleUrls: ['./synchronizer-accounting-interface.component.scss'],
  standalone: false,
})
export class SynchronizerAccountingInterfaceComponent
  implements OnInit, OnDestroy
{
  public readonly config = inject(DynamicDialogConfig);
  public readonly confirmDialogService = inject(ConfirmDialogService);
  private readonly accountingInterfaceService = inject(
    AccountingInterfaceService,
  );
  private readonly ref = inject(DynamicDialogRef, { optional: true });

  accountingInterfaceId: number = 0;
  alerts: PreInvoicingAlertModel[] = [];
  errorMessage: string = '';
  isSynchronizing: boolean = false;
  hasSynchronized: boolean = false;
  private inputSubscription?: Subscription;

  ngOnInit() {
    const input$ = this.config.data?.inputs$;
    if (!input$) {
      console.error('inputs$ no está definido en config.data');
      return;
    }

    this.inputSubscription = input$.subscribe(
      (inputs: { accountingInterfaceId: number }) => {
        this.accountingInterfaceId = inputs.accountingInterfaceId;
      },
    );
  }

  ngOnDestroy() {
    this.inputSubscription?.unsubscribe();
  }

  cancel() {
    this.ref?.close();
  }

  async syncUp() {
    if (this.isSynchronizing || this.hasSynchronized) return;

    if (this.accountingInterfaceId <= 0) {
      this.errorMessage = 'No se recibió una interfaz contable válida.';
      return;
    }

    const accepted = await this.confirmDialogService.confirm(
      '¿Desea enviar los movimientos contables de esta interfaz a Siesa Cloud?',
    );

    if (accepted) {
      this.isSynchronizing = true;
      this.errorMessage = '';
      try {
        this.alerts = await firstValueFrom(
          this.accountingInterfaceService.sendCountableMovement(
            this.accountingInterfaceId,
          ),
        );
        this.hasSynchronized = true;
      } catch (error) {
        console.error(
          'Error al sincronizar los movimientos contables con Siesa.',
          error,
        );
        this.errorMessage =
          'No fue posible completar la sincronización con Siesa Cloud.';
      } finally {
        this.isSynchronizing = false;
      }
    }
  }
}
